import { trackEvent } from "src/Amplitude";
import { Avatar, Grid, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { TradeStyles } from "../trade/styles/Trade.styles";
import { useUserSlice } from "src/store/features/user.slice";
import GreenTick from "./icons/GreenTick";
import api from "src/store/features/api";
import { useAppDispatch } from "src/store/store";
export default function StrategyPlacedSuccess() {
  const {
    details: { name: userName },
    broker: { imgUrl, name, email },
  } = useUserSlice();

  const dispatch = useAppDispatch();
  const handleForceRefetch = () => {
    dispatch(api.util.invalidateTags(["getDcaStrategiesTag"]));
  };

  const classes = TradeStyles();
  const messagePartOne =
    "Your Scheduled order strategy has been created successfully. Thank you for choosing Caleb & Brown!";
  const messagePartTwo = " If you have any questions or concerns, please email me at ";

  useEffect(() => {
    trackEvent("View Success Message", {}, "DCA");
    setTimeout(() => {
      handleForceRefetch();
    }, 2000);
  }, []);

  return (
    <Grid container height={"100%"} mt={2}>
      {/* Order Placed */}
      <Grid item xs={12} alignSelf={"center"}>
        <Stack spacing={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
          <Typography fontWeight={"bold"} fontSize={"18px"}>
            Plan Created
          </Typography>
          <GreenTick />
        </Stack>
      </Grid>
      {/* Broker message */}
      <Grid item xs={12} justifyContent="center" display="flex" mt={8}>
        <Grid item sx={{ position: "absolute" }}>
          <Avatar
            src={imgUrl}
            sx={{
              width: "95px",
              height: "95px",
              position: "relative",
              top: -48,
              border: "2px solid #002035",
            }}
          />
        </Grid>
        <Grid item xs={12} className={classes.messageContainer}>
          <Typography mt={4} fontSize={"16px"} fontWeight={600}>
            {"Hi, " + userName!}
          </Typography>
          <Typography mb={2} fontSize={"14px"}>
            {messagePartOne}
          </Typography>
          <Typography mb={2} fontSize={"14px"}>
            {messagePartTwo} <b>{email}</b>
          </Typography>
          <Typography fontWeight="bold" textAlign={"left"} mx={2} pb={2} fontSize={"14px"}>
            {`Your Broker, ${name}.`}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}
